
<mat-toolbar class="header">
    <mat-toolbar-row>
        <span class="logo">
            <a class="navbar-brand" href="/#/inicio">
            <img src="assets/images/generico/logo-login.png" width="30%" style="margin-top: -21px;">
            </a>
        </span>
        <span class="example-spacer"></span>
        <div *ngIf="!identity || !token"></div>
        <div *ngIf="identity || token">
            <button mat-button style="color: black !important" (click)="openPerfil()">
            {{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}
            </button>
        <button mat-button [matMenuTriggerFor]="menu">
            <mat-icon mat-button [matMenuTriggerFor]="menu">settings</mat-icon> Opciones
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item href="">
                <mat-icon>build
                </mat-icon>Ajustes
            </button>
            <button mat-menu-item href="" (click)="logout()">
                <mat-icon>exit_to_app
                </mat-icon>Cerrar Sesi&oacute;n
            </button>
        </mat-menu>
        </div>
    </mat-toolbar-row>
</mat-toolbar>



<div class="container" *ngIf="!buscando">

    <mat-card class="example-card">
        <mat-card-header>
            <div class="row" style="width: 100%;">
            <div mat-card-avatar class="example-header-image"></div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="title1b">Tótem de consulta</div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
                <p>Dirección de Obras Municipales</p>
            </div>
            </div>
        </mat-card-header>
        <mat-card-content>
  
        <div class="row">
  
            <div class="rol-div">
                <h4 class="card-title">Búsqueda por Rol</h4>
                <mat-form-field class="mat-field-rol">
                <input matInput type="text" placeholder="Nº Rol" [formControl]="rol">
                <button mat-button *ngIf="rol.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="rol.setValue('')">
                    <mat-icon>close</mat-icon>
                </button>
                </mat-form-field>
            </div>
  
        </div>

        <div class="row">
  
            <div class="rol-div">
                <h4 class="card-title">Búsqueda por Dirección</h4>
                <mat-form-field class="mat-field-rol">
                    <input matInput type="text" placeholder="Calle" [formControl]="calle">
                    <button mat-button *ngIf="calle.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="calle.setValue('')">
                    <mat-icon>close</mat-icon>
                    </button>
                    
                </mat-form-field>&nbsp;
                <mat-form-field class="mat-field-rol">
                    <input matInput type="text" placeholder="Nº Calle" [formControl]="nroCalle">
                    <button mat-button *ngIf="nroCalle.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="nroCalle.setValue('')">
                    <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
    
            <div class="btn-cont">
                <button class="btn-busqueda" mat-raised-button (click)="buscar(rol.value, calle.value, nroCalle.value)"
                        [disabled]="((!rol.valid && !calle.valid && !nroCalle.valid) || (rol.valid && calle.valid) || (rol.valid && nroCalle.valid)) ">Búsqueda</button>
            </div>
    
        </div>
  
        </mat-card-content>
        <mat-card-actions></mat-card-actions>
    </mat-card>
  
</div> 

<div class="container" *ngIf="buscando">
    <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <p align="right">
        <button color="primary" mat-raised-button  (click)="volver()">Volver a buscar</button>
        </p>




        <mat-card class="example-card">
            <mat-card-header>
                <div class="row" style="width: 100%;">
                    <div class="get-data-cont">
                        <p align="center"> Rol : {{ rol_busqueda }}</p>
                        <mat-tab-group>
                            <mat-tab label="Información">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 div-inforol-cont">
                                        
                                        <div class="col-lg-4 col-md-4 -col-sm-4">
                                            <label>Manzana</label><input matInput [value]="inforol ? inforol.res.fieldData.Pro_Propie_Manzana : '---'" disabled>
                                        </div>
                                        <div class="col-lg-4 col-md-4 -col-sm-4">
                                            <label>Afectacion a Utilidad Pública (AUP)</label><input matInput [value]="inforol ? inforol.res.fieldData.Pro_Propie_Afecta : '---'" disabled>
                                        </div>
                                        <div class="col-lg-4 col-md-4 -col-sm-4">
                                            <label>Plan Regulador</label><input matInput [value]="inforol ? inforol.res.fieldData.Pro_Propie_Zona_Edif : '---'" disabled>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 mapinfo-div">
                                        <div class="col-lg-4 col-md-4 -col-sm-4">
                                            <label>Destino</label><input matInput [value]="inforol ? inforol.res.fieldData['Param_Destino 2::PDe_Descripcion'] : '---'" disabled>
                                        </div>
                                        <div class="col-lg-4 col-md-4 -col-sm-4">
                                            <label>Ubicación</label><input matInput [value]="inforol ? inforol.res.fieldData.Pro_Propie_Ubicacion : '---'" disabled>                                        
                                        </div> 
                                        <div class="col-lg-4 col-md-4 -col-sm-4">
                                            <label>Lote / Sitio</label><input matInput [value]="inforol ? inforol.res.fieldData.Pro_Propie_Sitio : '---'" disabled>                                        
                                        </div> 
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 mapinfo-div">
                                        <div class="col-lg-8 col-md-8 -col-sm-8"><br>
                                            <label>Loteo</label><input matInput [value]="inforol ? inforol.res.fieldData['Conj_Habit::CONJ_Nombre_Completo'] : '---'" disabled>
                                        </div>
                                    </div>

                                    
                                    <div class="col-lg-12 col-md-12 col-sm-12 div-table-inforol">
                                        
                                        <table mat-table [dataSource]="direcciones" class="mat-elevation-z8">
    
                                            <!--- Note that these columns can be defined in any order.
                                                          The actual rendered columns are set as a property on the row definition" -->
    
                                            <!-- Position Column -->
                                            <ng-container matColumnDef="Propiedad_Direccion::PDI_Calle_Nombre">
                                                <th mat-header-cell *matHeaderCellDef> Calle </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Calle_Nombre'] }} </td>
                                            </ng-container>
    
                                            <!-- Name Column -->
                                            <ng-container matColumnDef="Propiedad_Direccion::PDI_Num_Calle">
                                                <th mat-header-cell *matHeaderCellDef> Nº </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Num_Calle'] }} </td>
                                            </ng-container>
    
                                            <!-- Weight Column -->
                                            <ng-container matColumnDef="Propiedad_Direccion::PDI_Num_Ex">
                                                <th mat-header-cell *matHeaderCellDef> Ex Nº </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Num_Ex'] }} </td>
                                            </ng-container>
    
                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="Propiedad_Direccion::PDI_Direc_Complemento_Tipo">
                                                <th mat-header-cell *matHeaderCellDef> Complemento </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Direc_Complemento_Tipo'] }} </td>
                                            </ng-container>
    
                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="Propiedad_Direccion::PDI_Direc_Complemento_Num">
                                                <th mat-header-cell *matHeaderCellDef> Compl. N </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Direc_Complemento_Num'] }} </td>
                                            </ng-container>
    
                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="Propiedad_Direccion::PDI_Anexo">
                                                <th mat-header-cell *matHeaderCellDef> Anexo </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Anexo'] }} </td>
                                            </ng-container>
    
                                            <!-- Symbol Column -->
                                            <ng-container matColumnDef="Propiedad_Direccion::PDI_Anexo_Num">
                                                <th mat-header-cell *matHeaderCellDef> Nº. Anexo </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Anexo_Num'] }} </td>
                                            </ng-container>
    
                                            <!-- Symbol Column -->
                                            <!-- <ng-container matColumnDef="exCalle">
                                                <th mat-header-cell *matHeaderCellDef> Ex Calle </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{ element['Propiedad_Direccion::PDI_Ex_Calle'] }} </td>
                                            </ng-container> -->
    
                                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                        </table>

                                        
                                    </div>
                                </div>
                            </mat-tab>
                            <!-- 
                            <mat-tab label="Permisos/Recepciones/Resoluciones/Regularizaciones">    
                                <div class="row">    
                                    <div class="col-lg-12 col-md-12 col-sm-12 div-table-inforol">
                                        
                                    </div>    
                                </div>    
                            </mat-tab>
                            <mat-tab label="Certificados Informes Previos">    
                                <div class="row">    
                                    <div class="col-lg-12 col-md-12 col-sm-12 div-table-inforol">
                                    </div>    
                                </div>    
                            </mat-tab> 
                            -->
                            <mat-tab label="Ubicación Google Maps">
                    
                                <agm-map [latitude]="lat" [longitude]="lng" [zoom]="13" [mapTypeControl]='true' #agm (centerChange)="centerChange($event)" (boundsChange)="ChangeMap($event)">
                                    <agm-marker *ngFor="let marcador of marcadores" [latitude]="marcador.lat" [longitude]="marcador.lng" [agmFitBounds]="true">
                                        <agm-info-window>
                                            <strong>{{marcador.titulo}}</strong>
                                            <p>{{marcador.descripcion}}</p>
                                        </agm-info-window>
                                    </agm-marker>
                                </agm-map>
    
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                </div>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
    
                </div>
            </mat-card-content>
            <mat-card-actions>
    
            </mat-card-actions>
        </mat-card>

    </div>
    </div>

    

</div>
    
  


  